<!-- Shell reused from the risk-assessment modals' global convention
     (styles/_confirm-dialog.scss): .confirm-dialog/.dialog-close/.dialog-icon/
     .dialog-title/.dialog-message/.dialog-actions .cancel-btn/.confirm-btn —
     see assessment-confirmation-modal for the same pattern with an embedded
     form. Opened with panelClass: 'confirm-dialog-panel' (complydome.component.ts). -->
<div class="confirm-dialog">
  <div *ngIf="isLoading" class="center-spinner loading">
    <mat-spinner></mat-spinner>
  </div>

  <button mat-icon-button class="dialog-close" (click)="onCancel()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog-icon icon-blue">
    <mat-icon>support_agent</mat-icon>
  </div>

  <h2 class="dialog-title">Submit a Support Request</h2>

  <div class="dialog-message">
    <form [formGroup]="supportForm" (ngSubmit)="onSubmit()" class="support-form">
      <!-- Category -->
      <div class="form-group">
        <label class="field-label">Category</label>
        <div class="category-tiles">
          <button type="button" class="category-tile" *ngFor="let opt of categoryOptions"
            [class.selected]="supportForm.get('category')?.value === opt.value"
            (click)="selectCategory(opt.value)">
            <mat-icon>{{ opt.icon }}</mat-icon>
            <span>{{ opt.label }}</span>
          </button>
        </div>
        <div class="tile-error"
          *ngIf="supportForm.get('category')?.touched && supportForm.get('category')?.hasError('required')">
          Select a category to continue.
        </div>
      </div>

      <!-- Subject -->
      <mat-form-field appearance="outline" class="full-width compact-field subject-field"
        *ngIf="supportForm.get('category')?.value === TicketCategoryEnum.OTHER">
        <mat-label>Subject</mat-label>
        <input matInput formControlName="subject" required>
        <mat-error *ngIf="supportForm.get('subject')?.hasError('required')">Required.</mat-error>
        <mat-error *ngIf="supportForm.get('subject')?.hasError('maxlength')">Maximum 100 characters</mat-error>
      </mat-form-field>

      <!-- Urgency -->
      <div class="form-group">
        <label class="field-label">Urgency</label>
        <mat-radio-group formControlName="urgency" class="urgency-options">
          <mat-radio-button *ngFor="let level of urgencyLevels" [value]="level.value"
            [class]="'urgency-option urgency-option--'+level.value.toLowerCase()">
            <mat-icon>{{level.matIcon}}</mat-icon>
            <span>{{level.value | titlecase}}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Description -->
      <mat-form-field appearance="outline" class="full-width compact-field">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" required rows="2" autosize
          placeholder="What happened, and what did you expect instead?"></textarea>
        <mat-error *ngIf="supportForm.get('description')?.hasError('required')">Required.</mat-error>
        <mat-error *ngIf="supportForm.get('description')?.hasError('minlength')">Minimum 20 characters required</mat-error>
        <mat-error *ngIf="supportForm.get('description')?.hasError('maxlength')">Maximum 2000 characters required</mat-error>
        <mat-hint align="end">Minimum 20 characters — {{ supportForm.get('description')?.value?.length || 0 }} / 2000</mat-hint>
      </mat-form-field>

      <!-- File Upload -->
      <div class="form-group form-group--last">
        <div class="file-dropzone" [class.dragging]="isDraggingFiles" (click)="fileInput.click()"
          (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onFilesDropped($event)">
          <mat-icon>attach_file</mat-icon>
          <span><strong>Attach files</strong> (optional) — click or drag and drop, up to {{maxFiles}}, 25MB total</span>
          <input #fileInput type="file" multiple [accept]="acceptedFileTypes" (change)="onFileSelected($event)"
            style="display: none;">
        </div>

        <!-- Uploaded files list -->
        <div class="uploaded-files" *ngIf="uploadedFiles.length > 0">
          <div class="file-chip" *ngFor="let file of uploadedFiles; let i = index"
            [matTooltip]="file.name + ' (' + (file.size | fileSize) + ')'">
            <mat-icon>insert_drive_file</mat-icon>
            <span class="file-name">{{ file.name }}</span>
            <button mat-icon-button type="button" (click)="removeFile(i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button class="cancel-btn" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button mat-raised-button class="confirm-btn btn-blue" (click)="onSubmit()"
      [disabled]="supportForm.invalid || isLoading">
      <mat-icon *ngIf="!isLoading">send</mat-icon>
      {{ isLoading ? 'Submitting…' : 'Create Ticket' }}
    </button>
  </div>
</div>
